import $ from 'jquery'
import 'bootstrap/dist/js/bootstrap.bundle'

// expose jQuery globally so other scripts can use it
window.$ = $
window.jQuery = $

import Rails from '@rails/ujs';

import Shuffle from 'shufflejs';
// expose globally if needed elsewhere
window.Shuffle = Shuffle;

import 'slick-carousel';

// Start Rails UJS
Rails.start();

// Sets default headers for all AJAX requests,
// If you define a header (X-CSRF-Token) in a specific AJAX call, it overrides the default from ajaxSetup()
$.ajaxSetup({
    headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
    }
});
